export const COLORS = {
  APIVIDEO: '#F15B2A',
  OVH: '#0050D7',
  LIGHT: 'white',
  MEDIUM: '#444',
  DARK: 'black',
}

const DEFAULT_THEMES = {
  BUTTONS_COLOR: COLORS.LIGHT,
  BUTTONS_HOVER_COLOR: COLORS.OVH,
  PROGRESS_BAR_COLOR: COLORS.OVH,
  PLAY_BUTTON_COLOR: COLORS.OVH,
  TITLE_COLOR: COLORS.LIGHT,
  OVERLAY_TEXT_COLOR: COLORS.LIGHT,
  OVERLAY_BACKGROUND_TOP_COLOR: COLORS.DARK,
  OVERLAY_BACKGROUND_BOTTOM_COLOR: COLORS.DARK,
}

export const THEMES = {
  DEFAULT: DEFAULT_THEMES,
}
